import { render, staticRenderFns } from "./product-schema.vue?vue&type=template&id=665c54e4&"
import script from "./product-schema.vue?vue&type=script&lang=js&"
export * from "./product-schema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665c54e4')) {
      api.createRecord('665c54e4', component.options)
    } else {
      api.reload('665c54e4', component.options)
    }
    module.hot.accept("./product-schema.vue?vue&type=template&id=665c54e4&", function () {
      api.rerender('665c54e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/product-schema/product-schema.vue"
export default component.exports